export const QD_CLOUD_LOCAL_STORAGE_KEY = 'qodana-cloud-storage.v1.'

// use '.' only to distinct version
export const versionDelimiter = '.'

export enum StorageUnits {
	THEME = 'theme.v1.',
	RECENT_PROJECTS = 'recent-projects.v1.',
	POLICY_AGREEMENT = 'policy-agreement.v1.',
	TELEMETRY_LEVEL = 'telemetry-level.v1.',
	IS_USER_ONBOARDED = 'is-user-onboarded.v1',
	CURRENT_ORGANIZATION_ID = 'current-organization-id.v1',
	IS_NEWSLETTER_VIEWED = 'is-newsletter-viewed.v1',
}
